import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatWon(n: number) {
  return new Intl.NumberFormat("ko-KR").format(Math.round(n));
}

export function ymd(d: Date) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function startOfMonth(d: Date) {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}

export function endOfMonth(d: Date) {
  return new Date(d.getFullYear(), d.getMonth() + 1, 0);
}

export function formatPercent(value: number, total: number, itemCount: number): string {
  if (total <= 0 || value <= 0) return "0";
  if (itemCount <= 1 || value >= total) return "100";
  const pct = (value / total) * 100;
  if (pct < 0.5) return "<1";
  if (pct >= 99.5) return "99";
  return String(Math.round(pct));
}
